module.exports = __webpack_public_path__ + "img/live-tea-bg.a5b2d30e.png";